export default __webpack_public_path__ + "static/media/oscer-pres-abdominal-distension.33a14a2f.svg";